import { IoChatbubbles } from 'react-icons/io5';
import { Button, Divider } from '@inexture/core';
import img1 from '@/assets/img/footer/contact_girl.png';

const LiveChat = () => {
  return (
    <>
      <section>
        <div className="bg-[#f5f5f5] border-b border-gray-200">
          <div className="container">
            <div className="relative bg-gray-100 rounded-b-md">
              <div className="grid grid-cols-12 gap-6 items-center pt-5 pb-1">
                <div className="col-span-12 lg:col-span-3 relative">
                  <img
                    src={img1}
                    alt="Customer support agent smiling"
                    loading="lazy"
                    className="w-3/5 !h-[250px] -mt-5 lg:-mt-20 block"
                    style={{ objectFit: 'none' }}
                  />
                </div>

                <div className="col-span-12 lg:col-span-5">
                  <h1 className=" font-normal text-[#666666]  text-[30px] mb-1">
                    Tot uw dienst
                  </h1>

                  <p className="text-sm text-[#536878] text-[17px] font-semibold text-slate-600 mb-1">
                    Van 08:00 tot 20:00
                  </p>

                  <p className="text-sm text-slate-500 text-[14px] text-[#666666] max-w-xl leading-7">
                    Aarzel niet om ons te contacteren,
                    <br className="hidden lg:block" />
                    we helpen u graag verder met al uw vragen.
                  </p>
                </div>

                <div className="col-span-12 lg:col-span-3">
                  <Button bg="#536878" h={70} radius="md" size="md">
                    <div className="flex items-center gap-5 h-20 justify-between rounded-xl  text-white overflow-hidden shadow-sm">
                      <span className="w-[60px] text-center flex items-center justify-center">
                        <IoChatbubbles size={50} />
                      </span>
                      <Divider
                        color="#3e4f5c"
                        orientation="vertical"
                        h="100px"
                      />
                      <span
                        className="w-[calc(100%-60px)] block text-center"
                        aria-label="Open live chat"
                      >
                        Live Chat Support
                      </span>
                    </div>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LiveChat;
